import 'dayjs/locale/pt-br'
import React from 'react'
import dayjs from 'dayjs'
import {Card} from '../components/Card'
import {Typography} from '../components/Typography'
import {Button} from '../components/Button'

const BlogCard = ({title, image, publish, author, slug}) => {
  return (
    <Card>
      <Card.Image src={image} />
      <Card.Content>
        <Card.Title title={title}>{title}</Card.Title>

        <Typography
          color="gray-900"
          className="overflow-hidden truncate whitespace-nowrap"
          title={author}
        >
          {author}
        </Typography>
        <Typography
          color="gray-900"
          className="overflow-hidden truncate whitespace-nowrap"
        >
          {dayjs(publish).locale('pt-br').format('DD [de] MMMM [de] YYYY')}
        </Typography>
      </Card.Content>
      <Card.Action>
        <Button as="a" fullWidth className="uppercase" href={`/${slug}`}>
          Leia o artigo
        </Button>
      </Card.Action>
    </Card>
  )
}

export {BlogCard}
